import { memo, type ReactNode } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

type MobileVersionsPanelWrapperProps = {
  onClose: () => void;
  children: ReactNode;
};

export const MobileVersionsPanelWrapper = memo(({ onClose, children }: MobileVersionsPanelWrapperProps) => {
  return (
    <div className="fixed z-1 flex h-screen w-screen flex-col ads:bg-base bg-gray-1">
      <div className="flex h-12 w-full items-center justify-between ads:border-ads-gray-5 border-gray-5 border-b px-4">
        <h4 className="font-semibold ads:text-primary text-14 text-gray-12">Versions</h4>
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          icon={XIcon}
          label="Close versions"
          onClick={onClose}
          size="medium"
        />
      </div>
      <div className="flex w-full flex-1 flex-col items-start justify-start overflow-auto">{children}</div>
    </div>
  );
});

MobileVersionsPanelWrapper.displayName = 'MobileVersionsPanelWrapper';
